module.exports = __webpack_public_path__ + "static/media/reminder-disabled-icon.9978fac4.svg";